import React, {useContext} from 'react';
import './App.scss';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import URLS from './navigation/routes';
import {ToastContext} from './contexts/toastContext';
import PrivateRoute from './navigation/PrivateRoute';
import Login from './components/auth/Login';
import AppWindow from './layout/AppWindow';
import Projects from './components/projects/Projects';
import Planning from './components/planning/Planning';
import Profile from './components/profile/Profile';
import Selections from './components/selections/Selections';
import Admin from './components/admin/Admin';
import Feedback from './components/feedback/Feedback';
import Toast from './components/_common/Toast';

const App = () => {
  const {showToast} = useContext(ToastContext);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path={URLS.LOGIN} element={<Login />} />
          <Route
            path='/'
            element={
              <PrivateRoute>
                <AppWindow />
              </PrivateRoute>
            }
          >
            <Route
              path={URLS.MAIN.PROJECTS}
              element={<Projects />}
            />
            <Route
              path={URLS.MAIN.PLANNING}
              element={<Planning />}
            />
            <Route
              path={URLS.MAIN.PROFILE}
              element={<Profile />}
            />
            <Route
              path={URLS.MAIN.SELECTIONS}
              element={<Selections />}
            />
            <Route
              path={URLS.MAIN.ADMIN}
              element={<Admin />}
            />
            <Route
              path={URLS.MAIN.FEEDBACK}
              element={<Feedback />}
            />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toast />
    </div>
  );
}

export default App;
